<script lang="ts">
  let {
    width = '100%',
    height = '20px',
    rounded = 'md'
  }: {
    width?: string;
    height?: string;
    rounded?: 'sm' | 'md' | 'lg' | 'full';
  } = $props();

  const roundedClasses: Record<string, string> = {
    sm: 'rounded',
    md: 'rounded-lg',
    lg: 'rounded-xl',
    full: 'rounded-full'
  };
</script>

<div
  class="animate-shimmer bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100
         dark:from-dark-tertiary dark:via-dark-elevated dark:to-dark-tertiary
         bg-[length:200%_100%] {roundedClasses[rounded]}"
  style="width: {width}; height: {height};"
  aria-hidden="true"
></div>
